import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconInstagramComponent } from "./med-icon-instagram.component";

@NgModule({
  declarations: [
    MedIconInstagramComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconInstagramComponent,
  ],
})
export class MedIconInstagramModule { }
